import { RedirectCommand, Routes } from '@angular/router';
import { createCrmWorkspaceResolvedGuard } from '@pinnakl/crm/data-access';
import { authGuard } from './auth/auth-guard';

// The add-in has no app-level shell to fall back on, so a blocked route would leave an empty pane —
// redirect to a page that explains it and offers a retry instead.
const crmWorkspaceResolvedGuard = createCrmWorkspaceResolvedGuard(
  router => new RedirectCommand(router.parseUrl('/workspace-unavailable'), { skipLocationChange: true }),
);

export const routes: Routes = [
  { path: '', redirectTo: '/communication', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('../features/login/login.component').then(m => m.LoginComponent),
  },
  {
    // authGuard must not share a canActivate array with crmWorkspaceResolvedGuard. Angular subscribes
    // to the guards of one array concurrently, so listing them in order does not sequence them: on a
    // signed-out load the workspace fetch starts anyway, and authInterceptor answers a token-less
    // request with NEVER. WebServiceProvider wraps every request in firstValueFrom, so that fetch
    // never settles, fetchWorkspaces() never reaches its `finally`, and the store's inFlight promise
    // stays pending forever — every later loadWorkspaces() is handed that dead promise, hanging
    // /communication after the user logs in. An ancestor's canActivateChild does resolve before a
    // route's own canActivate, so this extra level is what actually sequences "authenticate, then
    // resolve the workspace".
    path: '',
    canActivateChild: [authGuard],
    children: [
      {
        path: 'workspace-unavailable',
        loadComponent: () =>
          import('../features/workspace-unavailable/workspace-unavailable.component').then(
            m => m.WorkspaceUnavailableComponent,
          ),
      },
      {
        path: 'meeting-note',
        canActivate: [crmWorkspaceResolvedGuard],
        loadComponent: () =>
          import('../features/meeting-note/meeting-note.component').then(m => m.MeetingNoteComponent),
      },
      {
        path: 'communication',
        canActivate: [crmWorkspaceResolvedGuard],
        loadComponent: () =>
          import('../features/communication/communication.component').then(m => m.CommunicationComponent),
      },
    ],
  },
];
